module.exports = __webpack_public_path__ + "static/media/box-heart.f08e23d8.svg";